// Module
var code = "<div layout=\"column\" class=\"full-height\"> <oms-orders-table-row-task task=\"$ctrl.order.fulfillmentLines[0].pickupTask\" columns=\"$ctrl.columns\"> </oms-orders-table-row-task> <oms-orders-table-row-task task=\"$ctrl.order.fulfillmentLines[0].destinationTask\" columns=\"$ctrl.columns\"> </oms-orders-table-row-task> </div> ";
// Exports
export default code;